var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full"},[_c('div',{staticClass:"text-center text-3xl py-6"},[_vm._v(_vm._s(_vm._("You are offline")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }